<template>
	<div class="w-100 invisible-scroll">
		<!-- use the below section wen single card is ter -->
		<!-- <section class="banner-single-cards" id="hideinmobile">
			<div
				class="banner-firstcard w-100 position-relative d-flex align-items-center justify-content-between w-100"
			>
				<img
					src="../../assets/img/advertisement/firstcardbars.png"
					style="position: absolute; right: 0; top: 0; height: 95%"
					alt=""
				/>
				<div>
					<div class="fs-15 fw-M fam-inter color-white">
						Skip the queue. Get interview-ready in 15 minutes
					</div>
					<div class="fs-13 fw-R fam-inter color-white">
						Verify your skills with Instant Interview. Let recruiters come to
						you.
					</div>
				</div>
				<div class="d-flex align-items-center" style="z-index: 2">
					<img src="../../assets/img/advertisement/singlecard1.svg" alt="" />
					<div class="adv-whitebtn mt-2 pointer" style="width: fit-content">
						Start Instant Interview
					</div>
				</div>
			</div>
			<div
				class="banner-firstcard banner-secondcard w-100 position-relative d-flex align-items-center justify-content-between w-100"
			>
				<div>
					<div class="fs-15 fw-M fam-inter color-white">
						Where do you stand among 10,000+ software engineers?
					</div>
					<div class="fs-13 fw-R fam-inter color-white">
						Take a quick assessment and get a verified score recruiters trust.
					</div>
				</div>
				<div class="d-flex align-items-center" style="z-index: 2">
					<img src="../../assets/img/advertisement/singlecard2.svg" alt="" />
					<div class="adv-whitebtn mt-2 pointer" style="width: fit-content">
						Take Assessment
					</div>
				</div>
			</div>
			<div
				class="banner-firstcard banner-third w-100 position-relative d-flex align-items-center justify-content-between w-100"
			>
				<div>
					<div class="fs-15 fw-M fam-inter color-white">
						2,000+ candidates got hired last month
					</div>
					<div class="fs-13 fw-R fam-inter color-white">
						Real jobs, real offers, verified companies. Your turn.
					</div>
				</div>
				<div class="d-flex align-items-center" style="z-index: 2">
					<img src="../../assets/img/advertisement/singlecard3.svg" alt="" />
					<div class="adv-whitebtn mt-2 pointer" style="width: fit-content">
						Explore Jobs
					</div>
				</div>
			</div>
			<div
				class="banner-firstcard w-100 position-relative d-flex align-items-center justify-content-between w-100"
			>
				<img
					src="../../assets/img/advertisement/firstcardbars.png"
					style="position: absolute; right: 0; top: 0; height: 95%"
					alt=""
				/>
				<div>
					<div class="fs-15 fw-M fam-inter color-white">
						Never miss a recruiter again
					</div>
					<div class="fs-13 fw-R fam-inter color-white">
						Get instant alerts when someone views your profile or sends an
						interview invite.
					</div>
				</div>
				<div class="d-flex align-items-center" style="z-index: 2">
					<img src="../../assets/img/advertisement/singlecard4.svg" alt="" />
					<div class="adv-whitebtn mt-2 pointer" style="width: fit-content">
						Download App
					</div>
				</div>
			</div>
		</section> -->
		<!-- use below section wen there are more cards -->
		<section
			ref="bannerScroll"
			class="d-flex align-items-center gap-16px overflow-x-auto overflow-y-hidden invisible-scroll"
			@scroll.passive="onBannerScroll"
		>
			<div
				v-for="card in visibleCards"
				:key="card.type"
				:class="['position-relative', look(card).cardClass]"
			>
				<img
					v-if="look(card).image"
					:src="look(card).image"
					:class="look(card).imageClass"
					alt=""
				/>
				<section
					class="adv-copy position-relative d-flex flex-column justify-content-between h-100"
					style="z-index: 1"
				>
					<div class="fs-15 fw-M fam-inter color-white">
						{{ card.title }}
					</div>
					<div class="adv-body fs-13 fw-R fam-inter color-white">{{ card.body }}</div>
					<div
						role="button"
						tabindex="0"
						:class="['adv-whitebtn mt-2 pointer', look(card).buttonClass]"
						style="width: fit-content"
						@click="runAction(card.action)"
						@keydown.enter="runAction(card.action)"
					>
						{{ card.cta }}
					</div>
				</section>
				<!-- Arc around the person's head: a full arc is 100%. The figure sits left of it, clear of the art. -->
				<div
					v-if="card.asset === 'profile_progress'"
					class="adv-head-arc"
					aria-hidden="true"
				>
					<svg viewBox="0 0 84 84">
						<path class="adv-arc-track" :d="ARC_PATH" pathLength="100" />
						<path
							class="adv-arc-fill"
							:d="ARC_PATH"
							pathLength="100"
							stroke-dasharray="100"
							:stroke-dashoffset="arcOffset(card)"
						/>
					</svg>
					<span v-if="completionOf(card) !== null" class="adv-arc-value fam-inter">
						<strong>{{ completionOf(card) }}%</strong>
						<small>complete</small>
					</span>
				</div>
				<span v-if="card.badge" class="adv-attention-tag fam-inter">{{ card.badge }}</span>
			</div>
		</section>
		<div class="adv-dot-viewport">
			<div class="adv-dot-track">
				<span
					v-for="i in visibleCards.length"
					:key="i"
					:class="[
						'adv-dot',
						i - 1 === activeBannerIndex ? 'adv-dot--active' : 'adv-dot--small',
					]"
				></span>
			</div>
		</div>

		<PaymentComingSoonModal
			:showModal.sync="showPaymentComingSoonModal"
			:fromInstantInterview="true"
		/>
		<LaptopJobPref
			v-if="showJobPreference"
			:showModal="showJobPreference"
			:modalId="'jobprefernce'"
			@close-modal="showJobPreference = false"
		/>
	</div>
</template>

<script>
import PaymentComingSoonModal from "@/views/MyProfile/PaymentComingSoonModal.vue";
import laptopPerson from "@/assets/img/advertisement/laptopman.svg";
import ladderPerson from "@/assets/img/advertisement/ladderman.svg";
import resumePerson from "@/assets/img/advertisement/resumeman.svg";
import phoneAlerts from "@/assets/img/advertisement/fourthimage.png";
import locationArt from "@/assets/img/advertisement/location.webp";

const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.hire3x.candidate&pli=1";
const MAX_CARDS = 4;
const MIN_CARDS = 3;
// 240° arc of radius 38, open at the bottom: starts bottom-left, runs over the top, ends bottom-right.
const ARC_PATH = "M9.09 61 A38 38 0 1 1 74.91 61";

// The pipeline names an artwork and an action; only these are drawn or run, so it never sends URLs or markup.
const LOOKS = {
	laptop_person: { cardClass: "adv-laptop-card", image: laptopPerson, imageClass: "laptopman-position" },
	ladder_person: { cardClass: "adv-ladder-card", image: ladderPerson, imageClass: "ladderman-position", buttonClass: "adv-take-asmnt-btn" },
	resume_person: { cardClass: "adv-resume-card", image: resumePerson, imageClass: "resumeman-position" },
	phone_alerts: { cardClass: "adv-fourth-card", image: phoneAlerts, imageClass: "laptopman-position h-100", buttonClass: "adv-take-asmnt-btn" },
	profile_progress: { cardClass: "adv-profile-card", image: laptopPerson, imageClass: "laptopman-position" },
	location_globe: { cardClass: "adv-location-card", image: locationArt, imageClass: "adv-location-art" },
};
const ACTIONS = {
	open_instant_interview: "openInstantInterviewModal",
	open_assessments: "goToAssessment",
	open_jobs: "goToJobs",
	open_app_store: "openAppStore",
	open_profile: "goToProfile",
	open_job_preferences: "openJobPreference",
};
// The frontend fallback: shown when the dashboard API fails, and fills up to three if it sends fewer.
const DEFAULT_BANNERS = [
	{
		type: "mock_interview",
		title: "Get interview-ready in 15 mins",
		body: "Verify your skills with Get Verified\nLet recruiters come to you.",
		cta: "Start Interview",
		action: "open_instant_interview",
		asset: "laptop_person",
	},
	{
		type: "download_app",
		title: "Never miss a recruiter again",
		body: "Get instant alerts when someone\nviews your profile.",
		cta: "Download App",
		action: "open_app_store",
		asset: "phone_alerts",
	},
	{
		type: "explore_jobs",
		title: "2,000+ Hired Monthly",
		body: "Real jobs, real offers, verified\ncompanies. Your turn.",
		cta: "Explore Jobs",
		action: "open_jobs",
		asset: "resume_person",
	},
];

function isText(value) {
	return typeof value === "string" && value.trim().length > 0 && value.length <= 160;
}

function isUsable(card) {
	return (
		!!card &&
		typeof card === "object" &&
		isText(card.type) &&
		isText(card.title) &&
		isText(card.body) &&
		isText(card.cta) &&
		Object.prototype.hasOwnProperty.call(LOOKS, card.asset) &&
		Object.prototype.hasOwnProperty.call(ACTIONS, card.action) &&
		(card.badge === undefined || isText(card.badge))
	);
}

function rank(card) {
	return typeof card.priority === "number" && isFinite(card.priority) ? card.priority : Number.MAX_SAFE_INTEGER;
}

export default {
	components: {
		PaymentComingSoonModal,
		// Loaded on first click, so the dashboard does not download the form up front.
		LaptopJobPref: () => import("@/views/JobSearch/LaptopJobPref.vue"),
	},
	props: {
		// The dashboard API's banners, each with its copy, artwork key and action; null uses the defaults.
		banners: {
			type: Array,
			default: null,
		},
	},
	data() {
		return {
			activeBannerIndex: 0,
			showPaymentComingSoonModal: false,
			showJobPreference: false,
			ringReady: false,
			ARC_PATH,
		};
	},
	mounted() {
		// One frame at 0% first, so the arc visibly fills to the real value.
		requestAnimationFrame(() => {
			this.ringReady = true;
		});
	},

	watch: {
		// The API's banners can change the card count; re-read the scroll so the active dot exists.
		"visibleCards.length"() {
			this.$nextTick(this.onBannerScroll);
		},
	},
	computed: {
		// The API's order, unusable cards dropped, topped up to three from the defaults, four at most.
		visibleCards() {
			const seen = new Set();
			const cards = (Array.isArray(this.banners) ? this.banners : [])
				.filter(isUsable)
				.sort((a, b) => rank(a) - rank(b))
				.filter((card) => !seen.has(card.type) && seen.add(card.type));
			DEFAULT_BANNERS.forEach((card) => {
				if (cards.length < MIN_CARDS && !seen.has(card.type)) {
					seen.add(card.type);
					cards.push(card);
				}
			});
			return cards.slice(0, MAX_CARDS);
		},
	},
	methods: {
		look(card) {
			return LOOKS[card.asset];
		},
		runAction(action) {
			const method = ACTIONS[action];
			if (method) this[method]();
		},
		// The pipeline's completion figure, the same one that decided to show this card.
		completionOf(card) {
			const value = card.reason && card.reason.profileCompletion;
			if (!(typeof value === "number" && value >= 0 && value <= 100)) return null;
			return Math.floor(value);
		},
		arcOffset(card) {
			const percent = this.ringReady ? this.completionOf(card) || 0 : 0;
			return 100 - percent;
		},
		openAppStore() {
			window.open(PLAY_STORE_URL, "_blank", "noopener,noreferrer");
		},
		openInstantInterviewModal() {
			this.showPaymentComingSoonModal = true;
		},
		goToAssessment() {
			this.$router.push({ name: "AssessmentMarketplace" }).catch(() => {});
		},
		goToJobs() {
			this.$router.push({ name: "JobSearch" }).catch(() => {});
		},
		goToProfile() {
			this.$router.push({ name: "CandidateDashboard" }).catch(() => {});
		},
		// Laptop edits preferences in a modal, as on the home page; mobile has its own route.
		openJobPreference() {
			if (window.innerWidth >= 1024) {
				this.showJobPreference = true;
				return;
			}
			this.$router.push({ name: "JobPreference" }).catch(() => {});
		},
		onBannerScroll() {
			const container = this.$refs.bannerScroll;
			if (!container) return;

			// Scroll progress spread over every dot, so each lights up even when three cards fit on screen.
			const maxScroll = container.scrollWidth - container.clientWidth;
			const last = this.visibleCards.length - 1;
			const progress = maxScroll > 0 ? Math.min(1, Math.max(0, container.scrollLeft / maxScroll)) : 0;
			const newIndex = Math.round(progress * last);

			if (newIndex !== this.activeBannerIndex) {
				this.activeBannerIndex = newIndex;
			}
		},
	},
};
</script>

<style>
.banner-firstcard {
	height: 75.4px;
	background: linear-gradient(
		18.45deg,
		#073787 0.46%,
		#073583 30.97%,
		#083078 58.08%,
		#0a2765 85.2%,
		#0c1c4b 111.18%,
		#0d1b49 113.44%
	);
	border-radius: 16px;
	overflow: hidden;
	padding: 15px;
}
.banner-secondcard {
	background: url("../../assets/img/advertisement/mediumbluebg.png") no-repeat
		center center !important;
}
.banner-third {
	background: url("../../assets/img/advertisement/singlecard3png.png") no-repeat
		center center !important;
}
.adv-dot-viewport {
	/* One dot per banner, all visible: the row sizes to the card count. */
	width: fit-content;
	overflow: hidden;
	margin: 12px auto 0;
	display: flex;
	align-items: center;
	height: 28px;
}

.adv-dot-track {
	display: flex;
	align-items: center;
	gap: 8px;
	flex-shrink: 0;
	transition: transform 0.35s ease;
}

.adv-dot {
	border-radius: 100px;
	flex-shrink: 0;
	transition: width 0.35s ease, min-width 0.35s ease, height 0.35s ease,
		background 0.35s ease;
}

.adv-dot--small {
	width: 8px;
	height: 8px;
	background: #cecece;
	min-width: 8px;
}

.adv-dot--active {
	width: 19px;
	height: 8px;
	background: #333333;
	min-width: 19px;
}
/* Marquee container */
.adv-marquee-wrapper {
	width: 100%;
	overflow: hidden;
}

.adv-marquee-track {
	display: flex;
	gap: 16px;
	width: max-content;
	will-change: transform;
}

/* Shared card styles */

/* Shared card styles */
.adv-ladder-card,
.adv-laptop-card,
.adv-resume-card,
.adv-fourth-card,
.adv-profile-card,
.adv-location-card {
	padding: 14px;
	width: max(323px, calc((var(--adv-w, 960px) - 32px) / 3));
	height: 165px;
	border-radius: 15px;
	overflow: hidden;
	flex-shrink: 0;
	background-size: cover !important;
}

.adv-ladder-card {
	background: url("../../assets/img/advertisement/mediumbluebg.png") no-repeat
		center center;
}
.adv-laptop-card {
	/* background: url("../../assets/img/advertisement/darkbluebg.png") no-repeat
		center center; */
	background: linear-gradient(
		219.01deg,
		#073787 -12.92%,
		#073583 17.42%,
		#083078 44.39%,
		#0a2765 71.36%,
		#0c1c4b 97.2%,
		#0d1b49 99.45%
	);
}
.adv-resume-card {
	background: url("../../assets/img/advertisement/starbluebg.png") no-repeat
		center center;
}
.adv-fourth-card {
	background: linear-gradient(282.39deg, #4863e9 -2.41%, #283883 119.71%);
}
.adv-profile-card {
	background: linear-gradient(110deg, #123a8a 0%, #1a56c4 60%, #2a6fe0 100%);
}
.adv-location-card {
	background: linear-gradient(110deg, #741a12 0%, #6a1712 55%, #4e1211 100%);
}
.adv-location-art {
	position: absolute;
	right: 0;
	bottom: 0;
	width: 116px;
}
.adv-attention-tag {
	position: absolute;
	right: 0;
	bottom: 0;
	z-index: 1;
	padding: 3px 10px 3px 12px;
	border-top-left-radius: 12px;
	background: #d9534a;
	font-size: 11px;
	font-weight: 500;
	color: #ffffff;
}
/* Line breaks arrive as plain newlines in the copy, where the old cards had <br />. */
.adv-body {
	white-space: pre-line;
}
/* Centred on the head of laptopman.svg, which sits 50px from the right and 91px from the bottom. */
.adv-head-arc {
	position: absolute;
	right: 8px;
	bottom: 49px;
	width: 84px;
	height: 84px;
}
.adv-head-arc svg {
	display: block;
	width: 100%;
	height: 100%;
	overflow: visible;
	/* Tilted so the gap falls over the right shoulder rather than straight down. */
	transform: rotate(-25deg);
}
.adv-arc-track,
.adv-arc-fill {
	fill: none;
	stroke-width: 5;
	stroke-linecap: round;
}
.adv-arc-track {
	stroke: rgba(255, 255, 255, 0.22);
}
.adv-arc-fill {
	stroke: #ffc94d;
	transition: stroke-dashoffset 1.1s cubic-bezier(0.22, 1, 0.36, 1);
}
/* Left of the arc, in the free space between the copy and the art. */
.adv-arc-value {
	position: absolute;
	right: calc(100% + 2px);
	top: 54px;
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	line-height: 1;
	white-space: nowrap;
}
.adv-arc-value strong {
	font-size: 22px;
	font-weight: 800;
	color: #ffc94d;
}
.adv-arc-value small {
	margin-top: 2px;
	font-size: 10px;
	font-weight: 500;
	color: rgba(255, 255, 255, 0.8);
}
@media (prefers-reduced-motion: reduce) {
	.adv-arc-fill {
		transition: none;
	}
}
.adv-whitebtn {
	padding: 7.52638px 15.0528px;
	background: #4a7eff;
	border-radius: 94px;
	text-align: center;
	font-family: "Montserrat", sans-serif;
	font-weight: 600;
	font-size: 13.1712px;
	color: #ffffff;
}
.adv-take-asmnt-btn {
	background: #ffffff !important;
	color: #4a7eff !important;
}
.laptopman-position {
	position: absolute;
	right: 0;
	bottom: 0;
}
.resumeman-position {
	position: absolute;
	top: 0.5px;
	right: -6px;
	height: 101%;
}
.ladderman-position {
	position: absolute;
	right: 0;
	top: 14px;
}
.color-white {
	color: #ffffff;
}
.w-70 {
	width: 70%;
}
.color-091B2E {
	color: #091b2e;
}

.adv-dot-viewport {
	width: fit-content;
	overflow: hidden;
	margin: 12px auto 0;
	display: flex;
	align-items: center;
	height: 28px;
}
.adv-dot-track {
	display: flex;
	align-items: center;
	gap: 8px;
	flex-shrink: 0;
	transition: transform 0.35s ease;
}
.adv-dot {
	border-radius: 100px;
	flex-shrink: 0;
	transition: width 0.35s ease, height 0.35s ease, background 0.35s ease;
}
.adv-dot--small {
	width: 8px;
	height: 8px;
	background: #cecece;
}
.adv-dot--active {
	width: 19px;
	height: 8px;
	background: #333333;
}

@media (max-width: 1028px) {
	.adv-ladder-card,
	.adv-laptop-card,
	.adv-resume-card,
	.adv-fourth-card,
	.adv-profile-card,
	.adv-location-card {
		width: var(--adv-w, 100%);
	}
	/* prevent page scroll interference during swipe */
	.adv-marquee-wrapper {
		touch-action: pan-y;
	}
}
</style>
